<template>

    <div class="row" style="height: 100vh;">

        <div class="col-lg-9 col-md-8 d-none d-lg-block d-md-block" style="padding-left: 0px !important; padding-right: 0px !important;">

            <img src="../../../assets/img/Logo_banner2.png" style="width: 100%; height: 100%;" />

        </div>
        <div class="col-lg-3 col-md-4 col-sm-12" style="background-color: #EFEFFF;">

            <!--<form class="form-horizontal form-material text-center" id="loginform" style="padding-top: 30px;">-->
            <div class="form-horizontal form-material text-center" style="padding-top: 30px;">

                <!--<h3 class="text-center m-b-20"> Iniciar Sesión </h3>-->

                <div class="form-group" style="padding-top: 30px; padding-bottom: 30px;">
                    <div class="col-xs-12 text-center">

                        <img src="/assets/images/Logo_Horizontal_Xpress_Full_Color.png" style="max-height: 200px; max-width: 200px;" />

                    </div>
                </div>


                <h3 class="text-center m-b-20"> Iniciar Sesión </h3>

                <div class="text-center">
                    <hr />
                </div>

                <div class="form-group">
                    <div class="col-xs-12">
                        <input id="inpTxtCorreo" class="form-control" type="email" required="" placeholder="Correo" v-model="variables.usuario.login" @keydown.enter.prevent="VerificarCuentasLogin();">
                        <div id="msgErrorCorreo" class="text-danger" v-if="v$.variables.usuario.login.$error"> Debe completar el correo electrónico o digitar un correo válido </div>
                    </div>
                </div>

                <div class="form-group position-relative">
                    <div class="col-xs-12">
                        <div style="position: relative;">
                            <input id="inpPwdContrasena"
                                   :type="variables.mostrarPassword ? 'text' : 'password'"
                                   class="form-control"
                                   required
                                   placeholder="Contraseña"
                                   v-model="variables.usuario.password"
                                   @keydown.enter.prevent="VerificarCuentasLogin();"
                                   style="padding-right: 40px;">
                            <i id="btnMostrarPassword"
                               :class="variables.mostrarPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
                               style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;"
                               @click="variables.mostrarPassword = !variables.mostrarPassword"></i>
                        </div>
                        <div id="msgErrorContrasena" class="text-danger" v-if="v$.variables.usuario.password.$error"> Debe completar la contraseña </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-md-12">
                        <div class="d-flex no-block align-items-center">
                            <div class="ml-auto">
                                <router-link id="lnkOlvidoContrasena" to="/recover" class="text-muted"><i class="fas fa-lock m-r-5"></i> ¿Olvidó su contraseña? </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group text-center">
                    <div class="col-xs-12 p-b-20">
                        <button id="btnIngresar" class="btn btn-block btn-lg btn-primary btn-rounded" v-on:click="VerificarCuentasLogin();" type="button"> Ingresar </button>
                    </div>
                </div>

                <div class="form-group m-b-0">
                    <div class="col-sm-12 text-center">
                        ¿No tiene una cuenta? <router-link id="lnkRegistrese" to="/register" class="text-info m-l-5"> <b> Registrese </b> </router-link>
                        <br />
                    </div>
                </div>

                <div class="form-group m-b-0">
                    <div class="col-sm-12 text-center">
                        <a id="lnkNecesitaAyuda" href="javascript:void(0);" class="text-muted" @click="variables.showAyuda = true;">
                            <i class="fas fa-question-circle m-r-5"></i> ¿Necesita ayuda?
                        </a>
                    </div>
                </div>
            </div>

        </div>


        <VueFinalModal v-model="variables.showAccounts"
                       content-class="modal-dialog modal-dialog-centered modal-lg"
                       content-transition="vfm-fade"
                       overlay-transition="vfm-fade">
            <div id="mdlCuentas" class="modal-content">

                <div class="modal-header">
                    <h4 class="modal-title"> Listado de Cuenta </h4>
                    <!--<button type="button" class="close" v-on:click="variables.showAccounts = false;">&times;</button>-->
                </div>
                <div class="modal-body">

                    <div class="form-material">
                        <div class="input-group mb-3">
                            <input id="inpTxtBusqueda" ref="busquedaCia" type="text" class="form-control" placeholder="Búsqueda" v-model="variables.busqueda">
                        </div>
                    </div>

                    <table class="table">
                        <thead class="thead-dark">
                            <tr>
                                <th></th>
                                <th>Cuenta</th>
                                <th>Nombre</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="cuenta in displayedRecordsCias" v-bind:key="cuenta.Email">
                                <td><button type="button" class="close" id="btnCuentaLogin"><i class="ti-check-box" v-on:click="Login(cuenta)"> </i></button></td>
                                <td> {{ cuenta.Email }} </td>
                                <td> {{ cuenta.Nombre }} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button id="btnCerrarCuentas" type="button" class="btn btn-light" @click="variables.showAccounts = false;"> Cerrar </button>
                </div>
            </div>
        </VueFinalModal>

        <VueFinalModal v-model="variables.showPlanVencimientoModal"
                       content-class="modal-dialog modal-dialog-centered modal-md"
                       content-transition="vfm-fade"
                       overlay-transition="vfm-fade"
                       :esc-to-close="false"
                       :click-to-close="false"
                       @before-close="ModalPlanVencimientoClose">
            <div id="mdlVencimientoPlan" class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"> Vencimiento de Plan </h4>
                </div>
                <div class="modal-body">

                    <div class="row">

                        <div class="col-12">

                            <p>
                                Estimado(a) Cliente:
                                <br />
                                Su plan <strong>se encuentra vencido hace {{ variables.diasVencido }} día(s)</strong>. <br />
                                Para continuar con el uso de la aplicación debe renovar el plan al siguiente <strong><a id="lnkRenovarPlan" href="https://technosoftcr.com/cuenta/Login.aspx" target="_blank">LINK</a></strong> <br />
                                Si ya realizó el pago puede comunicarse al <strong>2105-8095</strong> o puede enviar el comprobante de pago a <strong>cobros@facelcr.com</strong> indicando los siguientes datos: correo de su cuenta de inventarios, nombre, cédula y número telefónico. Estamos para servirle.

                            </p>

                        </div>

                    </div>

                </div>
                <div class="modal-footer">
                    <button id="btnCerrarVencimientoPlan" type="button" class="btn btn-light" @click="variables.showPlanVencimientoModal = false;"> Cerrar </button>
                </div>
            </div>
        </VueFinalModal>

        <VueFinalModal v-model="variables.showAyuda"
                       content-class="modal-dialog modal-dialog-centered modal-md"
                       content-transition="vfm-fade"
                       overlay-transition="vfm-fade">
            <div id="mdlAyuda" class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"> ¿Necesita ayuda? </h4>
                </div>
                <div class="modal-body">

                    <p class="text-center m-b-20"> Si tiene problemas para ingresar o alguna consulta, contáctenos por cualquiera de estos medios: </p>

                    <div class="login-ayuda-item">
                        <i class="fa fa-envelope"></i>
                        <span> {{ objects.config.general_info_correo }} </span>
                    </div>
                    <div class="login-ayuda-item">
                        <i class="fa fa-phone"></i>
                        <span> {{ objects.config.general_info_telefono }} </span>
                    </div>
                    <a id="lnkAyudaWhatsapp" class="login-ayuda-item login-ayuda-whatsapp" :href="objects.config.general_info_whatsapp" target="_blank" rel="noopener">
                        <img src="../../../assets/img/whatsapp.png" alt="WhatsApp" />
                        <span> Escríbanos por WhatsApp </span>
                    </a>

                </div>
                <div class="modal-footer">
                    <button id="btnCerrarAyuda" type="button" class="btn btn-light" @click="variables.showAyuda = false;"> Cerrar </button>
                </div>
            </div>
        </VueFinalModal>

    </div>

</template>

<script src="../controllers/loginCtrl.js"></script>

<style>

/*    html, body {
        height: 100%;
    }
*/

    .row {
        margin: 0px !important;
    }

    .login-ayuda-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 0;
        font-size: 14px;
    }

    .login-ayuda-item i {
        width: 18px;
        text-align: center;
        color: #6c757d;
    }

    .login-ayuda-whatsapp {
        color: inherit;
        text-decoration: none;
        border-top: 1px solid #eee;
        margin-top: 4px;
        padding-top: 12px;
    }

    .login-ayuda-whatsapp:hover {
        color: #25D366;
    }

    .login-ayuda-whatsapp img {
        width: 22px;
        height: 22px;
    }

</style>